export const getStringValue = (value: unknown) =>
  typeof value === 'string' ? value : '';

export const splitFullName = (fullName: string) => {
  const trimmed = fullName.trim();
  if (!trimmed) {
    return { firstName: '', lastName: '' };
  }
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: '' };
  }
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' '),
  };
};

export const getInitials = (fullName: string, email: string) => {
  const trimmed = fullName.trim();
  if (trimmed) {
    const parts = trimmed.split(/\s+/);
    const first = parts[0]?.[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] ?? '' : '';
    const combined = `${first}${last}`.toUpperCase();
    return combined || 'NA';
  }
  if (email) {
    return email.trim()[0]?.toUpperCase() ?? 'NA';
  }
  return 'NA';
};

export const formatDisplayValue = (value: string) =>
  value.trim() ? value : 'Not set';

export const getTabSlug = (value: string) =>
  value
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
